import "./AsideCalloutData.scss";

import React from "react";

import {
  Card,
  CardActions,
  CardContent,
  Typography
} from "@mui/material";

import { AsideCallOut } from "../../models/app-data-model";
import Button from "../button/Button";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type AsideCalloutDataProps = {
  asideCallout?: AsideCallOut;
};

const AsideCalloutData: React.FC<AsideCalloutDataProps> = (props: AsideCalloutDataProps) => {
  const copyData = props.asideCallout?.copy && <RichTextBlock content={props.asideCallout?.copy} />;
  return <Card className={props.asideCallout?.variant}>
    
    <CardContent>
      {props.asideCallout?.headline && (
        
        <h4 className="headline">
          {props.asideCallout?.headline}
        </h4>
      )}
      {copyData && (
        <Typography variant="body2" component="div">
          {copyData}
        </Typography>
      )}
    </CardContent>
    <CardActions>
      {props.asideCallout?.button_group.map((button, index) => <Button className={button.button_type} label={button.label} reference={button.reference} link={button.link} key={index} ></Button>)}
    </CardActions>
  </Card>
};

export default AsideCalloutData;
